<template>
	<div class="tab-body">
		<div class="search">
			<el-form ref="form" :model="searchParams" label-width="80px">
				<el-row>
					<el-col :span="2">
						<el-form-item>
							<el-checkbox @change="chgCheck" v-model="checked">查最新</el-checkbox>
						</el-form-item>
					</el-col>
					<el-col :span="4">
						<el-form-item label="成员">
							<el-select size="mini" v-if="checked" v-model="searchParams.usid"
								@change="list" clearable placeholder="请选择">
								<el-option v-for="item in this.users" :key="item.id" :label="item.name"
									:value="item.id">
								</el-option>
							</el-select>
							<el-select size="mini" v-else v-model="searchParams.tmId" @change="list"
								clearable placeholder="请选择">
								<el-option v-for="item in this.teamAndMembers" :key="item.id"
									:label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="5">
						<el-form-item v-show="!checked" label="产品">
							<el-select size="mini" v-model="searchParams.proId" clearable @change="chgPro"
								placeholder="请选择">
								<el-option v-for="item in productList" :key="item.id" :label="item.name"
									:value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="5">
						<el-form-item v-show="!checked" label="Sprint">
							<el-select size="mini" v-model="searchParams.sprintId" @change="chgSprint"
								clearable placeholder="请选择">
								<el-option v-for="item in this.sprintListData" :key="item.id"
									:label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>


					<div class="search-btn">
						<el-button type="primary" size="mini" @click="search">搜索</el-button>
						<el-button size="mini" @click="clearSearchVal">清空</el-button>

					</div>
				</el-row>
			</el-form>
		</div>
		<div class="dataTable autoFlex" v-if="listData">
			<el-table class="table" :data="listData.records" stripe border height="auto" v-loading="listLoading">
				<el-table-column prop="wkdate" width="180" label="完成时间"></el-table-column>
				<el-table-column prop="dbColumn_pmid" width="90" label="团队成员"></el-table-column>
				<el-table-column v-if="checked" prop="sprName" label="Sprint"></el-table-column>
				<el-table-column prop="sblName" label="执行任务"></el-table-column>
				<el-table-column v-if="checked" prop="wchours" width="120" label="本次完成工时">
				</el-table-column>
				<el-table-column v-else prop="wchours" width="210" label="累计完成 / 消耗 / 工时">
					<template slot-scope="props">
						{{ props.row.wchours == null ? 0 : props.row.wchours }} /
						{{ props.row.realgs == null ? 0 : props.row.realgs }} /
						{{ props.row.hopegs == null ? 0 : props.row.hopegs }}h
					</template>
				</el-table-column>

				<el-table-column prop="kfAdvance" width="90" label="开发进度">
					<template slot-scope="props">
						{{ props.row.kfAdvance == null ? 0 : (props.row.kfAdvance*101).toFixed(1)  }}%
					</template>
				</el-table-column>

				<el-table-column v-if="!checked" prop="cnt" width="70" label="日志数">
				</el-table-column>
				<el-table-column label="操作" fixed="right" width="220px">
					<template slot-scope="scope">
						<div class="dataTable-operator">
							<el-button size="mini" @click="toDetail(scope.row)">详情</el-button>
							<el-button size="mini" v-if="isShow(scope.row)"
								@click="toUpdate(scope.$index, scope.row)">编辑</el-button>
							<el-button size="mini" v-if="isShow(scope.row)" icon="el-icon-delete"
								type="danger" @click="remove(scope.$index, scope.row)">删除</el-button>
						</div>
					</template>
				</el-table-column>
			</el-table>
			<div class="pageBar">
				<el-pagination @size-change="sizeChange" @current-change="currentChange" :total="listData.total"
					:page-size="page.size" :current-page="page.current" :layout="this.$constant.page.layout"
					:page-sizes="this.$constant.page.pageSizes"></el-pagination>
			</div>
		</div>
		<edit ref="edit"></edit>
		<show ref="show"></show>
	</div>
</template>
<script>
import edit from './edit.vue';
import show from './show.vue';
import api from '@/api/sprint/devRecord/devRecord.js';
import apiSBL from '@/api/sprint/sprintBacklog/sprintBacklog.js';
import apiTeamMember from '@/api/team/teamMember/teamMember.js';
import productApi from '@/api/product/product/product.js';


export default {
	name: 'devRecord',
	components: {
		edit, show
	},
	data() {
		return {
			searchParams: {},
			isShowMoreSearch: false,
			listLoading: false,
			listData: [],
			selected: [],
			page: new this.$constant.pageObj(),
			sprintId: '',
			sprintListData: [], //获取到产品的sprint
			selectProd: '',		//选中的产品id
			productList: [],	//装载产品的数据

			teamAndMembers: [],	//查询出来的团队和成员
			teamID: '',	// 团队 
			member: {},  //当前用户在团队中的角色
			teamMsg: {},

			checked: false,
			users: [],

			me: {},
		};
	},
	methods: {

		chgCheck() {
			console.log(" chgCheck() ", this.checked)
			if (this.checked) {
				api.listUsers({}, res => {
					this.users = res.data.usrs
					this.users.unshift({ id: "0", name: "全部" })
					this.searchParams.usid = "0"
					this.listData = res.data.page;

				});
			} else {
				this.searchParams = {};
				this.list();
			}

		},
		isShow(row) {
			//console.log(" row ", row,this.me)
			if ('ad' == this.me.role) {
				return true
			}
			if (this.me.name == row.dbColumn_pmid && row.kfAdvance < 100) {
				//只能修改删除今天的
				let now = new Date();
				if( row.wkdate.indexOf(now.format("yyyy-MM-dd"))!=-1 ){
	                     return true
				}
			
			}
			return false
		},


		//页面初始化,获取产品数据，从浏览器获取存储的产品和sprint数据， 主要是初始化顶部搜索框条件
		init() {

			this.productList = this.$caches.products.get();
			const proId = this.$caches.pid.get()
			const sprid = this.$caches.sprintId.get()
			this.selectProd = proId
			this.checked = false;

			if (proId) {
				//浏览器存有id则设置产品的id
				this.searchParams.proId = proId;
			}

			if (!this.productList) {
				//获取产品数据并存入productData
				productApi.list4Select({}, response => {


					this.productList = response.data;
					this.searchParams.name = this.productList[0].name;
					this.$caches.products.set(this.productList);

					//初始化搜索框内容
					if (this.productList && !this.selectProd && this.searchParams.proId) {

						//console.log("浏览器存的产品id",proId);
						//查询该产品的sprint数据并存入	sprintListData	

						apiSBL.getSBLByProId(this.searchParams, response => {
							this.sprintListData = response.data
							//查看浏览器是否存有sprintid
							//console.log("初始化到这里!!!!!!!");

							if (sprid) {
								// TODO 是否要校验这个从浏览器获取的sprintID是不是 属于浏览器存的产品的sprint
								this.sprintId = sprid;
								this.searchParams.sprintId = sprid;
								this.list();
							} else {
								//如果浏览器没有sprintID则默认选中产品的第一个sprint  并存入浏览器
								if (this.sprintListData && this.sprintListData[0]) {
									this.sprintId = this.sprintListData[0].id;
									this.searchParams.sprintId = this.sprintListData[0].id
									this.$caches.sprintId.set(this.sprintListData[0].id)
								}

								//产品与sprint设置完毕则调用list

							}
							this.list();
							// this.chgCheck();

							if (!this.teamAndMembers || this.teamAndMembers.length == 0) {
								apiTeamMember.getTMemberBySprId(true, response => {
									if (response.data) {
										this.teamAndMembers = response.data
										this.$caches.teammembes.set(this.teamAndMembers);
									}
								});
							}
						});

					}
					this.listLoading = false;
				})
			} else {
				if (this.searchParams.proId) {
					apiSBL.getSBLByProId(this.searchParams, response => {
						this.sprintListData = response.data
						//查看浏览器是否存有sprintid
						//console.log("初始化到这里!!!!!!!");

						if (sprid) {
							// TODO 是否要校验这个从浏览器获取的sprintID是不是 属于浏览器存的产品的sprint
							this.sprintId = sprid;
							this.searchParams.sprintId = sprid;
							//this.list();

						} else {
							//如果浏览器没有sprintID则默认选中产品的第一个sprint  并存入浏览器
							if (this.sprintListData && this.sprintListData[0]) {
								this.sprintId = this.sprintListData[0].id;
								this.searchParams.sprintId = this.sprintListData[0].id

								this.$caches.sprintId.set(this.sprintListData[0].id)
								//产品与sprint设置完毕则调用list
							}

						}
						this.list();
						// this.chgCheck();

						if (!this.teamAndMembers || this.teamAndMembers.length == 0) {
							apiTeamMember.getTMemberBySprId(true, response => {
								if (response.data) {
									this.teamAndMembers = response.data
									this.$caches.teammembes.set(this.teamAndMembers);
								}
							});
						}
						this.listLoading = false;
					});
				}

			}



		},
		//获取数据
		list() {
			let params = this.$utils.merger(this.searchParams, this.page);
			if (this.searchParams.sprintId) {
				api.list(params, response => {
					this.listData = response.data.page;
					this.listLoading = false;
				});
			} else {
				this.$utils.msg.warning("请选择Sprint后查询");
				this.listData = []
			}

		},
		//去编辑
//去编辑（实际走新增：再补一次消耗/完成）
toUpdate(index, row) {
  this.$utils.confirm.warning('提示', '确定编辑 时间最近一条 吗？', () => {
    // 复制一份，删掉 id，让 edit.vue 走新增逻辑
    let newRow = JSON.parse(JSON.stringify(row));
    delete newRow.id;
    this.$refs.edit.open(null, newRow, '编辑');
  })
},
		//去详情
		toDetail(row) {

			this.$refs.show.open(row, row.sblName + ' - 开发日志', this.me);
		},
		//删除
		remove(index, row) {
			let parameter = {
				id: row.id
			}
			//console.log("row.id", row.id)

			this.$utils.confirm.warning('提示', '确定删除 时间最近一条 吗？', () => {
				api.remove(
					parameter,
					response => {
						this.$utils.msg.success(response.msg);
						this.list();
					},
					response => {
						this.$utils.msg.warning(response.msg);
					}
				);
			});
		},
		//改变每页显示数量
		sizeChange(val) {
			this.page.size = val;
			this.list();
		},
		//改变现在的页码
		currentChange(val) {
			this.page.current = val;
			this.list();
		},
		//产品改变
		chgPro(val) {
			this.$caches.pid.set(val)
			let proId = val
			this.selectProd = val
			this.searchParams.proId = val
			apiSBL.getSBLByProId({ proId }, response => {
				this.sprintListData = response.data
				if (response.data.length !== 0) {
					this.searchParams.sprintId = this.sprintListData[0].id
					this.sprintId = this.sprintListData[0].id
					this.$caches.sprintId.set(this.sprintListData[0].id)

					this.getTeamMember()
					this.list();
				} else {
					this.list();
					this.$caches.sprintId.remove()
					this.searchParams.sprintId = '';
					this.sprintId = '';
				}
			});

		},
		//sprint改变
		chgSprint(val) {
			this.sprintId = val
			this.searchParams.sprintId = val;
			this.$caches.sprintId.set(val)

			this.teamAndMembers = [];
			this.getTeamMember();
			this.list();
		},
		//获取团队成员
		getTeamMember() {
			apiTeamMember.getTMemberBySprId(false, response => {
				if (response.data) {
					this.teamAndMembers = response.data;
					this.$caches.teammembes.set(this.teamAndMembers);
				}
			});
			// }
		},

		//搜索
		search() {
			// console.log('searchParams:', this.searchParams);
			this.list();
		},
		//清空搜索框
		clearSearchVal() {
			this.searchParams = {};
			this.list();
		}
	},
	mounted() {
		//取得当前用户
		this.me = this.$caches.user.get();
		this.init();
	}
};
</script>

<style lang="scss" scoped="scoped">
@import '~common/custom/css/common.scss';
</style>
